module.exports = __webpack_public_path__ + "img/loginBack.e4d23658.png";